<template>
  <v-menu bottom left transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :ripple="false" icon v-bind="attrs" v-on="on"
        class="no-background-hover text-capitalize mr-sm-5 mr-0"><v-icon class="mr-2">mdi-web</v-icon> 
        <!-- <span class="d-none d-sm-flex">{{ currentLanguage }}</span> -->
        <v-icon class="d-none d-sm-flex">mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-list :class="$vuetify.theme.dark ? 'blue-lighten-2' : 'white-lighten-5'">
        <v-list-item-content class="pa-0">
          <v-list-item v-for="[icon, text] in links" :key="icon" link @click="toggleLanguage(text)">
            <v-list-item-title>{{ text }}</v-list-item-title>
          </v-list-item>
        </v-list-item-content>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    links: [
      ["mdi-inbox-arrow-down", "Eng"],
      ["mdi-send", "Hin"],
    ],
  }),
  methods: {
    toggleLanguage(language) {
      this.$i18n.locale = language === 'Eng' ? 'en' : 'hi';
      // Save the selected language to localStorage
      localStorage.setItem('userLanguage', this.$i18n.locale);
    },
    loadUserLanguage() {
      // Load the user's selected language from localStorage
      const savedLanguage = localStorage.getItem('userLanguage');
      if (savedLanguage) {
        this.$i18n.locale = savedLanguage;
      }
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale === 'en' ? 'Eng' : 'Hin';
    }
  },
  mounted() {
    // Load the user's selected language when the component is mounted
    this.loadUserLanguage();
  }
};
</script>
